// src/components/GoToPremium.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import GoToPremiumDesktop from "./GoToPremiumDesktop";
import GoToPremiumMobile from "./GoToPremiumMobile";

export default function GoToPremium() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <GoToPremiumMobile /> : <GoToPremiumDesktop />;
}
